<script>
    import _ from 'lodash'
    import ServiceCredentialsDropdown from '../../../../shared/ServiceCredentialsDropdown.svelte'
    import { sanitize }  from '../../../../shared/utils.js'
    import SheetSelector from './SheetSelector.svelte'
    import FieldSelector from './FieldSelector.svelte'
    import PlaceForm     from '../../PlaceForm.svelte'

    export let type
    export let domain
    export let item
    export let errors

    // let sheet = { 
    //     id: '1syD_VoCcBHwEMmVbWwYqu5TcNCHiDwYTOwM5i7yJNZc', 
    //     range: 'Form Responses 1!A1:W1' 
    // }

    let sheet      = { id: null, range: null }
    let active     = null

    let data = {
        credential  : null,
        sheet       : { title: null, cells: [] },
        fields      : [],
    }

    function activate(step) {
        return () => {
            if(active === step) {
                active = null
            } else {
                active = step
            }
        }
    }

    function onStep(prop) {
        return result => {
            active = null
            data[prop] = result.detail
        }
    }

    function compute(sheet, data) {
        const source     = { place: 0 }
        return {
            id          : 0,
            kind        : type.kind,
            responsible : data.credential && data.credential.username,
            email       : data.credential && data.credential.email,
            name        : data.sheet.title,
            locator     : sheet.id && `https://docs.google.com/spreadsheets/d/${sheet.id}`,
            fields      : data.fields.map(f => _.assign(f, source)),
            connector   : {
                active      : true, 
                kind        : type.kind, 
                credentials : data.credential && data.credential.vaultId, 
                sheet       : sheet.id,
                range       : sheet.range,
            }
        }
    }

    $: item = compute(sheet, data)
</script>

<div class="ui basic segment">
    <div class="ui styled accordion w100">
        <!-- Credentials -->
        <div class="title" 
             class:active={ active === "credentials" } 
             on:click={ activate("credentials") }>
            <i class="dropdown icon"></i> 
            <span class="section-title">Credenciais</span> 
            {#if data.credential}
                <div class="ui tiny green label">
                    <i class="ui check icon"></i>
                    {data.credential.email}
                </div>
            {/if}
        </div>
        <div class="content" class:active={ active === "credentials" }>
            <ServiceCredentialsDropdown {domain} {type} on:done={onStep("credential")}></ServiceCredentialsDropdown>
        </div>

        <!-- Sheet ID -->
        <div class="title" 
             class:disabled={ !data.credential } 
             class:active={ active === "sheet" } 
             on:click={ activate("sheet") }>
            <i class="dropdown icon"></i> 
            <span class="section-title">Planilha</span>
            {#if data.sheet.cells.length > 0}
                <div class="ui tiny green label">
                    <i class="ui check icon"></i>
                    {data.sheet.cells.length} colunas
                </div>
            {/if}
        </div>
        <div class="content" class:active={ active === "sheet" }>
            <SheetSelector {domain} {sheet} {data} on:done={onStep("sheet")}  />
        </div>

        <!-- Fields -->
        <div class="title" 
             class:disabled={ !data.sheet.title }
             class:active={ active === "fields" } 
             on:click={ activate("fields") }>
            <i class="dropdown icon"></i> 
            <span class="section-title">Campos</span>
            {#if data.fields.length > 0}
                <div class="ui tiny green label">
                    <i class="ui check icon"></i>
                    {data.fields.length} campos
                </div>
            {/if}
        </div>
        <div class="content" class:active={ active === "fields" }>
            <FieldSelector {data} on:done={onStep("fields")}/>
        </div>

        <!-- Place Item -->
        <div class="title" 
             class:disabled={ data.fields.length == 0 }
             class:active={ active === "place" } 
             on:click={ activate("place") }>
            <i class="dropdown icon"></i> 
            <span class="section-title">Informações</span>
            {#if data.fields.length && item.name}
                <div class="ui tiny green label">
                    <i class="ui check icon"></i>
                    {item.name}
                </div>
            {/if}
        </div>
        <div class="content" class:active={ active === "place" }>
            <PlaceForm bind:item={item} {errors}></PlaceForm>
        </div>
    </div>
</div>

<style>
    .ui.styled.accordion.w100 {
        width: 100%;
    }

    .ui.styled.accordion.w100 > .title.disabled {
        pointer-events: none;
        opacity: .3;
    }

    .section-title {
        min-width: 100px;
        text-align: left;
        display: inline-block;

    }
</style>